import {z as zod} from "zod";

export type RetailLocationMicroStoreWorkspaceCapabilityConfiguration = Record<string, never>;

export const retailLocationMicroStoreWorkspaceCapabilityConfigurationValidator: zod.ZodType<RetailLocationMicroStoreWorkspaceCapabilityConfiguration> = zod.strictObject({});
